import { render } from "./FormSubmit.vue?vue&type=template&id=2e6d42ca"
import script from "./FormSubmit.vue?vue&type=script&lang=ts"
export * from "./FormSubmit.vue?vue&type=script&lang=ts"
script.render = render

export default script